import { FOOD_BENEFIT_URLS } from './endpoints.constants';

const API_URL = process.env.API_URL;
const EMPLOYEE_URL = `${API_URL}/${FOOD_BENEFIT_URLS.EMPLOYEE_ROOT}`;
const MANAGER_URL = `${API_URL}/${FOOD_BENEFIT_URLS.MANAGER_ROOT}`;

const ENDPOINTS_EMPLOYEE = {
  get : {
    initial : (employeeId) => `${EMPLOYEE_URL}/${employeeId}`,
    payrollClosure: () => `${EMPLOYEE_URL}/payroll-closure-date`
  },
  post : {
    create : (employeeId) => `${EMPLOYEE_URL}/${employeeId}`,
  },
  put : {

  },
  delete : {

  }
};

const ENDPOINTS_MANAGER = {
  get : {
    initial : (managerId) => `${MANAGER_URL}/${managerId}`,
  },
  post : {
    create : (managerId) => `${MANAGER_URL}/${managerId}`,
  },
  put : {
  },
  delete : {
  }
};

export {
  ENDPOINTS_EMPLOYEE,
  ENDPOINTS_MANAGER
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/food-benefit.endpoints.js